import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import DownPaymentAssistanceEstimatePage from "@/pages/tools/DownPaymentAssistanceEstimate";

export const Route = createFileRoute("/tools/down-payment-assistance-estimate")({
  head: () => seoHead("/tools/down-payment-assistance-estimate"),
  component: DownPaymentAssistanceEstimatePage,
});
